import { render, staticRenderFns } from "./bindDevice.vue?vue&type=template&id=615e004e&"
import script from "./bindDevice.vue?vue&type=script&lang=js&"
export * from "./bindDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports